import { Component, OnInit, Input, Pipe, PipeTransform, SecurityContext, OnDestroy, EventEmitter, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { JubloMessageApi, JubloMessengerHelper, JubloMessageTypes } from '../jublo-messenger/messageHelper';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { SharedDataService } from '../../shared/services/shared-data.service';
import { ActivatedRoute } from '@angular/router';
import { ColorList } from 'app/bars/topbar/topbarData';
import { CaseService } from 'app/shared/services/case.service';
import { CompanyService } from 'app/shared/services/company.service';
import { SubscriptionObject } from 'app/shared/models/standard.models';
import { UserService } from 'app/shared/services/user.service';

@Pipe({ name: 'safeHtml' })
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitized: DomSanitizer) { }
  transform(value: string) {
    return this.sanitized.sanitize(SecurityContext.HTML, this.sanitized.bypassSecurityTrustHtml(value));
  }
}

@Component({
  selector: 'case-messages',
  templateUrl: './case-messages.component.html',
  styleUrls: ['./case-messages.component.css']
})
export class CaseMessagesComponent implements OnInit, OnDestroy {

  @Input() case;
  @Input() caseSettings: string;
  @Input() notificationSets: any;
  @Input() selectedSet: any;
  @Output() fileClicked = new EventEmitter<string>();

  api = new JubloMessageApi(this.http);
  notifications: boolean = false;
  activeConversation = 'customer';
  conversationHeader = {
    name: '',
    phone: null,
    email: null
  }
  currentStakeholder: StakeHolderName = {
    stakeholderId: JSON.parse(localStorage.getItem('userInfo'))?.Name,
    name: localStorage.getItem('bearer')
  };
  message = new JubloMessengerHelper(this.sanitizer, this.sharedData, this.companyService);
  self: string;
  colorList = ColorList.colors;
  caseId: string;
  type = new JubloMessageTypes();
  customerMessages: JubloMessage[] = []
  messages: JubloMessage[] = [];
  partners;
  partnerSubscription: Subscription;
  partnerById: any = {}
  filteredMessages;
  partnerMessages: any = {};
  pendingMessages: JubloPendingMessage[] = [];
  editPendingMessage: PendingMessage;
  filteredPendingMessages: JubloPendingMessage[] = [];
  newMessageFiles: Array<File>;
  newMessageText: string = '';
  internalMessage = false;
  resendMessageText;
  checkTypes = ['internal', 'customer', 'company', 'system', 'systemInternal', 'offerAccept', 'partner'];
  internal = ['5bd55f91-ae0b-4289-911d-a4037a244360'];
  customer = [
    //'b493822e-bae1-4e96-889c-ae5f821c6473', WebServiceRequest
    '89a873df-acda-41ca-a680-c40f20f7329e',
    'd8e8ed6f-8582-4f0a-bc26-1307f32825ed',
    '77e3ae35-6955-4fbb-89a9-1992ee407dd6',
    '758a738b-e5db-4169-b1b8-63b6fdeff9b7'];
  offerAccept = ['04630a3b-6f6e-4c24-be3a-f56a0499c8c4'];
  system = [
    'b2114c29-d297-4a12-bda5-a400fbcaaf40',
    '1aabee02-1576-4dad-a995-3e8c272f8e82',
    '87806a15-0ae5-44a9-ba2e-ff2402b1345f',
    'c2de85a8-7ce7-4e1c-a229-5279e4ea5f2b',
    '8c300432-6ff5-4e6a-a259-1fb0e9877cbf',
    '8850aee1-48a3-48a6-aa98-2e1597b7b1d7',
    '99bc09b6-b7f7-46c0-a40b-5dfc27ec9cf0',
    '7bccdf15-ad49-4cc9-b358-68e08287f32f',
    'b56c96f0-0e8c-4a9f-8faf-70eea6f6b0b7',
    '6bef49c6-c9a1-4fd3-ae13-e9b28dfc7b6b',
    '7f42fb44-d8ea-491f-8bfc-0b63a5276ddf',
    'affa0591-e431-4543-a005-9200d71e5948',
    '69d4f294-ca74-4df1-b018-2e2779e775c5',
    '8c0e89f8-0186-4ded-96a1-806fa7846523',
    'd9cac90c-6aff-4067-8666-a61d07077379',
    '1f960a12-f5a8-4cd3-a474-bb41fd68a026',
    '47324550-1525-4d66-b975-f8c9c9301b15',
    'f92ed551-b7f5-49f8-8d76-e35fcefe33cd'
  ];
  systemInternal = ['dbe287c5-6011-47f3-88e8-eafa671d1ed6'];
  company = [
    'c3affd15-1834-44ff-9c5e-11763e6aabed',
    'e16ffab0-bbac-4a90-906c-27ec935deba4',
    '880a69de-65ea-4bd0-96bb-238999075b5b',
    '403358d3-f766-43c6-aa19-276c40c9cf5a',
    'a693c47f-9685-4bb6-bf6e-bcab86cb88de',
    '6deaca71-b600-4f4a-8923-3e5286190f4a'];
  partner = ['7cb47e5a-c66a-4198-8545-a97e9c285dd3'];
  subs: SubscriptionObject = {};
  validation; // copied from old messenger
  notificationSettings: NotificationSettings = new NotificationSettings();
  conversationRead = {
    'customer': false
  }
  constructor(
    private translate: TranslateService,
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    private sharedData: SharedDataService,
    private route: ActivatedRoute,
    private caseServer: CaseService,
    private companyService: CompanyService,
    private user: UserService
  ) { }

  ngOnInit(): void {
    this.caseId = this.route.snapshot.paramMap.get('id');
    this.self = localStorage.getItem('bearer');
    this.notifications = !this.case.disableNotifications;
    this.getMessages();
    this.subs['casePartners'] = this.caseServer.casePartners(this.caseId).subscribe({
      next: (data) => {
        if (!!data) {
          this.partners = data;
          this.caseServer.partnerCaseIdsFromPartnerData(data).forEach(partnerCaseId => {
            this.api.getPartnerMessages(partnerCaseId).subscribe({
              next: (messages: any[]) => {
                this.partnerMessages[partnerCaseId] = messages.filter(x => !!x.message).sort((a, b) => new Date(a.createdAt) < new Date(b.createdAt) ? 1 : -1);
                this.conversationRead[partnerCaseId] = true;
              },
              error: (err) => console.error(err)
            })
          });
        }
      }
    });
  }

  ngOnDestroy(): void {
    for (let key of Object.keys(this.subs)) this.subs[key].unsubscribe();
  }

  getMessages() {
    this.api.caseMessages(this.caseId).subscribe({
      next: (data: JubloMessage[]) => {
        //console.log(data)
        let m = this.message.cleanMessages(data.map(x => {
          return {
            ...x,
            showFiles: false,
            files: [],
            type: this.type.getMessageType(x.messageTypeId),
            sender: this.getSender(x),
            showMenu: false,
            seenAsRead: true
          }
        }));
        this.messages = this.messages.concat(m).filter(x => !this.systemInternal.includes(x.messageTypeId)).sort((a, b) => a.sentAt < b.sentAt ? 1 : -1);
        this.customerMessages = this.messages;
        this.conversationHeader = {
          name: this.case.customer.name,
          phone: this.case.customer.phone,
          email: this.case.customer.email
        }
        for (let x of Object.keys(this.partnerById)) {
          if (!!this.partnerById[x].messagesLoaded) this.partnerById[x].messagesLoaded = false;
        }
      },
      error: err => console.error(err),
      complete: () => {
        this.getFilesToMessages();
        this.api.caseMessageRead(this.caseId).subscribe(() => {
          this.conversationRead['customer'] = true;
         });
      }
    });
  }

  getFilesToMessages() {
    this.api.caseMessageFiles(this.caseId).subscribe((data: File[]) => {
      if (!!data) {
        data.forEach(file => { this.messages.filter(x => !!x.fileId && x.fileId.includes(file.fileId) && !x.files.find(y => y.fileId == file.fileId)).forEach(m => m.files.push(file)) });
      }
      this.getPending();
    });
  }

  getPartnerMessages(caseId: string, reload: boolean) {
    if (!this.partnerById[caseId]['messagesLoaded'] || reload) {
      this.partnerMessages = this.partnerMessages.filter(x => x.caseId != caseId)
      this.api.getPartnerMessages(caseId).subscribe(
        (data: PartnerMessage[]) => {
          if (!!data) {
            // filter empty messages
            let m = data.filter(x => !!x.message).map(x => this.partnerMessageToJubloMessage(x, caseId));
            this.partnerMessages = this.partnerMessages.concat(m);
            this.partnerById[caseId]['messagesLoaded'] = true;
            console.log(this.partnerById)
            this.filterMessages();
          }
        }
      );
      this.readPartnerMessage(caseId);
    }
  }

  readPartnerMessage(caseId: string) {
    this.api.caseMessageRead(caseId).subscribe(
      () => { this.conversationRead[caseId] = true }, (err) => console.error(err))
  }

  partnerMessageToJubloMessage(m: PartnerMessage, caseId: string): JubloMessage {
    return {
      caseId: caseId,
      description: m.message,
      diag: null,
      emailSent: false,
      fileId: m.files.map(x => x.fileId),
      files: m.files,
      messageId: m.id,
      messageReadAt: m.messageRead,
      messageReadByCustomer: false,
      messageTypeId: null,
      receiverMail: null,
      receiverMobile: null,
      sender: m.sentBy,
      sentAt: m.createdAt,
      sentBy: m.companyName ? { stakeholderId: m.companyName, name: m.sentBy } : null,
      sentByCustomer: m.companyName ? { stakeholderId: null, name: m.sentBy } : null,
      shortDescription: null,
      showFiles: false,
      smsSent: false,
      state: null,
      showMenu: false,
      type: !!this.partners && !!this.partners.toPartners && this.partners.toPartners.companyName == m.companyName ? 'fromPartner' : 'toPartner',
      seenAsRead: true
    }
  }

  pendingMessageToJubloMessage(m: PendingMessage, caseId: string): JubloMessage {
    return {
      caseId: caseId,
      description: !!m.shortDescription ? m.shortDescription : m.description,
      diag: null,
      emailSent: false,
      fileId: null,
      files: null,
      messageId: m.id,
      messageReadAt: null,
      messageReadByCustomer: false,
      messageTypeId: null,
      receiverMail: null,
      receiverMobile: null,
      sender: null,
      sentAt: m.sendingAt,
      sentBy: this.currentStakeholder,
      sentByCustomer: null,
      shortDescription: m.shortDescription,
      showFiles: false,
      smsSent: false,
      state: null,
      showMenu: false,
      type: 'planned'
    }
  }

  getSender(x) {
    if (!!x.sentBy && !!x.sentBy.stakeholderId && ['company', 'internal', 'partner'].includes(this.type.getMessageType(x.messageTypeId))) { return x.sentBy.name }
    if (!!x.sentByCustomer && !!x.sentByCustomer.stakeholderId && this.type.getMessageType(x.messageTypeId) == 'customer') { return x.sentByCustomer.name }
    return null
  }

  getPending() {
    this.api.getPendingNotifications(this.caseId).subscribe({
      next: (data: PendingMessage[]) => {
        this.pendingMessages = !!data ? data.filter(x => x.sending).map(x => { return { ...x, open: false, date: x.sendingAt.split('T')[0], time: x.sendingAt.split('T')[1].slice(0, 5) } }).sort((a, b) => a.sendingAt > b.sendingAt ? -1 : 1) : [];
        this.filterMessages();
      }
    });
  }

  async filterMessages() {
    let stringSearchIds = await this.message.filterVisibleByString(this.message.filterString);
    // console.log(this.allMessages.filter(x => !x.type))
    switch (this.activeConversation) {
      case ('internal'): {
        this.filteredMessages = this.messages.filter(x => x.type == 'internal');
        //console.log(this.filteredMessages);
        this.filteredPendingMessages = this.pendingMessages;
        break;
      }
      case ('customer'): {
        this.filteredMessages = this.messages.filter(x => !['toPartner', 'fromPartner'].includes(x.type) && x.messageTypeId != 'dbe287c5-6011-47f3-88e8-eafa671d1ed6');
        //console.log(this.filteredMessages);
        this.filteredPendingMessages = this.pendingMessages;
        break;
      }
      default: {
        this.filteredMessages = this.messages.filter(x => x.caseId == this.activeConversation);
        //console.log(this.filteredMessages)
        this.filteredPendingMessages = this.pendingMessages;
        break;
      }
    }
    if (stringSearchIds.length > 0) {
      this.filteredMessages = this.filteredMessages.filter(x => stringSearchIds.includes(x.messageId));
      this.filteredPendingMessages = this.pendingMessages.filter(x => stringSearchIds.includes(x.id));
    }
    // if (this.messageTo != 'internal') {
    //   this.filteredMessages = this.filteredMessages.filter(x => x.type != 'systemInternal' && ((x.smsSent || x.emailSent) && x.type != 'internal')); 
    // }
  }

  sendMessage() {
    let text = this.message.content.text;
    if (this.internalMessage) {
      this.api.sendCompanyOnlyMessage(this.caseId, text, this.message.content.files.map(x => x.fileId)).subscribe({
        next: () => this.addActivity('817fbd2c-5a75-4b83-96d1-01705ba03caf', this.translate.instant('Buttons.SendInternalMessage')),
        error: err => console.error(err)
      });
    } else {
      switch (this.activeConversation) {
        case ('customer'): {
          if (!!this.resendMessageText) { text = this.resendMessageText; }
          this.api.sendMessage(this.caseId, text, this.message.content.files).subscribe({
            next: () => {
              this.addActivity('6ca042b7-ea5a-4458-a03b-d43b37593e29', this.translate.instant('OfferDetails.ResponseToCustomer'));
              this.message.resetMessage();
            },
            error: err => console.error(err)
          });
          break;
        }
        case ('internal'): {
          this.api.sendCompanyOnlyMessage(this.caseId, text, this.message.content.files.map(x => x.fileId)).subscribe({
            next: () => {
              this.addActivity('817fbd2c-5a75-4b83-96d1-01705ba03caf', this.translate.instant('Buttons.SendInternalMessage'));
              this.message.resetMessage();
            },
            error: err => console.error(err)
          });
          break;
        }
        default: {
          this.api.sendMessageToPartner(this.activeConversation, text, this.message.content.files).subscribe({
            next: () => {
              this.message.resetMessage();
              setTimeout(() => {
                this.api.getPartnerMessages(this.activeConversation).subscribe({
                  next: (data: any[]) => {
                    this.partnerMessages[this.activeConversation] = data.sort((a, b) => new Date(a.createdAt) < new Date(b.createdAt) ? 1 : -1);
                    this.getConversation(this.activeConversation, this.partners.fromPartner.caseId == this.activeConversation ? this.partners.fromPartner : this.partners.toPartners.find(x => x.caseId == this.activeConversation))
                  },
                  error: (err) => console.log('error ocurred while loading the partner messages', err)
                })
              }, 1000);
            },
            error: err => console.error(err)
          });
          break;
        }
      }
    }
  }

  async resendMessage(x) {
    let text = this.message.extractMessage(x);
    this.message.content.text = text;
  }

  markAsUnread(type: string, partnerCaseId:any, event) {
    event.stopPropagation();
    event.preventDefault();
    switch(type){
      case 'partnerFrom':
      case 'partnerTo': {
        let partnerMessages = this.partnerMessages[partnerCaseId];
        if(!!partnerMessages && !!partnerMessages.length){
          let x = partnerMessages[partnerMessages.length - 1];
          this.api.markAsUnread(x.id).subscribe({
            next:() => { this.conversationRead[partnerCaseId] = false },
            error: err => console.log('could not mark message as unread', err)
          });
        }
        break
      }
      default: {
        this.conversationRead['customer'] = false;
        for (let x of this.messages) {
          this.api.markAsUnread(x.messageId).subscribe({
            next: () => {},
            error: err => console.log('could not mark message as unread', err)
          });
        }
        break
      }
    }
  }

  getStandardTexts() {
    if (this.message.showStandardTexts) {
      this.message.showStandardTexts = false;
    } else if (!this.message.standardTexts) {
      this.api.getStandardTexts().subscribe(
        (data: any) => {
          if (!!data) {
            //console.log(data)
            let parsedData = JSON.parse(data);
            this.message.standardTexts = parsedData.texts.filter(x => x.inMessage == true).sort((a, b) => a.header.toLowerCase() < b.header.toLowerCase() ? -1 : 1);
            this.message.showStandardTexts = true;
          }

        }
      )
    } else {
      setTimeout(() => {
        this.message.showStandardTexts = true
      }, 150);
    }
  }

  addStandardText(t) {
    this.message.content.text = this.message.content.text + t.content;
    this.message.showStandardTexts = false;
  }

  addActivity(type, text) {
    this.sharedData.setCaseActivity(type, text, this.newMessageText, '89a41c6c-6a83-4978-90bb-ca7ec2d19a26', this.route.snapshot.paramMap.get('id')).subscribe({
      error: err => console.error(err),
      complete: () => {
        this.messagePosted();
      }
    });
  }

  addFiles(files) {
    if (!!files && !files[0].name.includes('.msg')) {
      for (let file of files) {
        this.api.fileUpload(file).subscribe(
          (data) => {
            this.message.content.files.push(data)
            //console.log(this.message.content.files);
          },
          (err) => { console.log('could not upload file', err) }
        )
      }
    }
  }

  messagePosted() {
    this.messages = [];
    this.message.resetMessage();
    // let textarea = document.getElementById('newMessageText') as HTMLTextAreaElement;
    // textarea.style.height = '34px';
    this.newMessageText = '';
    setTimeout(() => this.getMessages(), 500);
  }

  getConversation(type: string, partner?) {
    this.activeConversation = type;
    //console.log(type, partner)
    if (type == 'planned') {
      this.messages = this.pendingMessages.map(x => this.pendingMessageToJubloMessage(x, this.case.caseId));
      //console.log(this.messages)
      this.conversationHeader = {
        name: this.case.customer.name,
        phone: this.case.customer.phone,
        email: this.case.customer.email
      }
    } else if (type != 'customer') {
      this.messages = this.partnerMessages[type].map(x => this.partnerMessageToJubloMessage(x, this.case.caseId));
      this.api.caseMessageRead(type).subscribe(() => { })
      this.conversationHeader = {
        name: partner.companyName,
        phone: partner.phone,
        email: partner.email
      }
    } else {
      this.conversationHeader = {
        name: this.case.customer.name,
        phone: this.case.customer.phone,
        email: this.case.customer.email
      }
      this.messages = this.customerMessages;
    }
  }

  prepareToggleNotifications() {
    if (!!this.notificationSets && this.notificationSets.length > 0) {
      let set = this.notificationSets.sort(((a: NotificationSets, b: NotificationSets) => a.priority < b.priority ? -1 : 1));
      this.notificationSettings.setId = set[0].id;
      set.forEach((x: NotificationSets) => this.notificationSettings.sets.push(x));
    }
    if (!!this.selectedSet) {
      this.notificationSettings.setId = this.selectedSet;
    }
  }

  // TO BE DEPRECATED
  toggleNotifications() {
    this.api.caseNotificationToggle(this.caseId, !!this.case.disableNotifications).subscribe(
      {
        next: () => {
          this.case.disableNotifications = !!this.case.disableNotifications ? null : 'fake';
          this.notifications = !this.notifications
        }
      }
    )
  }  

  editModePendingMessage(id: string) {
    this.editPendingMessage = this.pendingMessages.find(x => x.id == id);
  }

  pendingReject() {
    this.api.pendingMessageToggle(this.editPendingMessage.id).subscribe({
      complete: () => {
        this.pendingMessages.find(x => x.id == this.editPendingMessage.id).sending = false;
        this.pendingMessages = this.pendingMessages.filter(x => x.id != this.editPendingMessage.id);
        this.messages = this.messages.filter(x => x.messageId != this.editPendingMessage.id);
        this.filterMessages();
        document.getElementById('pendingMessageModalBtn').click();
      }
    });
  }

  pendingEdit() {
    let newDate = new Date(this.editPendingMessage.date + 'T' + this.editPendingMessage.time + 'Z');
    this.api.changePendingMessage(this.editPendingMessage.id, newDate).subscribe({
      complete: () => {
        let upDate = new Date(this.editPendingMessage.date + 'T' + this.editPendingMessage.time).toString();
        this.pendingMessages.find(x => x.id == this.editPendingMessage.id).sendingAt = upDate.substring(0, upDate.length - 1);
        this.messages.find(x => x.messageId == this.editPendingMessage.id).sentAt = upDate.substring(0, upDate.length - 1);
        this.filterMessages();
        document.getElementById('pendingMessageModalBtn').click();
      }
    });
  }

  findColor(type, stakeholder, customer) {
    let init;
    let regexPattern = /^[A-ZÆØÅ0-9]+$/i;
    let responsible = !!this.case.responsible.responsibleId ? this.case.responsible.name.trim().substring(0, 1).toUpperCase() : '';
    if (!!customer && customer != '') {
      init = customer.trim().substring(0, 1).toUpperCase();
      switch (type) {
        case 'b':
          if (!!init && regexPattern.test(init)) {
            return ColorList.colors[init].background;
          } else {
            return '#1F539F';
          }
        case 'c':
          if (!!init && regexPattern.test(init)) {
            return ColorList.colors[init].color;
          } else {
            return 'white';
          }
        case 'rb':
          if (!!responsible && regexPattern.test(init)) {
            return ColorList.colors[init].background;
          } else {
            return '#1F539F';
          }
        case 'rc':
          if (!!responsible && regexPattern.test(init)) {
            return ColorList.colors[init].color;
          } else {
            return 'white';
          }
        case 'rl':
          if (!!responsible && regexPattern.test(init)) {
            return responsible;
          } else {
            return '';
          }
        default:
          if (!!init && regexPattern.test(init)) {
            return init;
          } else {
            return '';
          }
      }
    } else if (!!stakeholder && stakeholder != '') {
      init = stakeholder.substring(0, 1).toUpperCase();
      switch (type) {
        case 'b':
          if (!!init && regexPattern.test(init)) {
            return ColorList.colors[init].background;
          } else {
            return '#1F539F';
          }
        case 'c':
          if (!!init && regexPattern.test(init)) {
            return ColorList.colors[init].color;
          } else {
            return 'white';
          }
        case 'rb':
          if (!!responsible && regexPattern.test(init)) {
            return ColorList.colors[init].background;
          } else {
            return '#1F539F';
          }
        case 'rc':
          if (!!responsible && regexPattern.test(init)) {
            return ColorList.colors[init].color;
          } else {
            return 'white';
          }
        case 'rl':
          if (!!responsible && regexPattern.test(init)) {
            return responsible;
          } else {
            return '';
          }
        default:
          if (!!init && regexPattern.test(init)) {
            return init;
          } else {
            return '';
          }
      }
    }
  }

  trackByMessageId(message) {
    return message.id
  }

  orderMailCopy() {
    navigator.clipboard.writeText(this.caseId + '@reply.jublo.dk');
  }

  fileClick(id:string){
    console.log('file got clicked');
    this.fileClicked.emit(id);
  }
}

interface JubloMessage {
  caseId: string;
  description: string;
  diag: any;
  emailSent: boolean;
  fileId: string[];
  files: File[];
  messageId: string;
  messageReadAt: string;
  messageReadByCustomer: boolean;
  messageTypeId: string;
  receiverMail: string;
  receiverMobile: string;
  sender: string;
  sentAt: string;
  sentBy: StakeHolderName;
  sentByCustomer: StakeHolderName;
  shortDescription: string;
  showFiles: boolean;
  smsSent: boolean;
  state: any;
  type: string;
  showMenu: boolean;
  seenAsRead?: boolean;
}

interface PartnerMessage {
  companyId: string;
  companyName: string;
  createdAt: string;
  files: File[];
  id: string;
  message: string;
  messageRead: string;
  sentBy: string;
}

interface File {
  extension: string;
  fileAccess: string;
  fileId: string;
  fileTypeId: string;
  originalName: string;
  path: string;
}

interface StakeHolderName {
  stakeholderId: string;
  name: string;
}

class PendingMessage {
  email: string;
  id: string;
  notificationTypeId: string;
  sending: boolean;
  sendingAt: string;
  shortDescription: string;
  description: string;
  sms: string;
  date: string;
  time: string;
}

class JubloPendingMessage extends PendingMessage {
  open: boolean;
  date: string;
  time: string;
}

class NotificationSettings {
  setId: string | null = null;
  sets: NotificationSets[] = []
  createCase: boolean = false;
  hourBefore: boolean = false;
  dayBefore: boolean = false;
}

class NotificationSets {
  id: string;
  name: string;
  priority: number;
}